export enum LanguageLocal {
    LanguageEN = 'en-US',
    LanguageCN = 'zh-CN',
}

//TODO: temp place here, will more the shareable component module for webinar/course module
export enum CourseLanguage {
    English = 'English',
    Mandarin = 'Mandarin',
}

//TODO: temp place here, will more the shareable component module for webinar/course module
export enum HourEarnedType {
    CPE = 'CPE',
    Training = 'Training',
}

export enum UiProgramType {
    Course,
    LiveWebinar,
    RecordedWebinar,
    Podcast,
}

export enum LanguageType {
    None = 0,
    English = 1,
    Chinese = 2,
}

export enum PublishStatus {
    Draft = 0,
    Published = 1,
    Archived = 2,
}

export enum PhoneValidationErrorCode {
    IsPossible = 0,
    InvalidCountryCode = 1,
    TooShort = 2,
    TooLong = 3,
    IsPossibleLocalOnly = 4,
    InvalidLength = 5,
    Null = -99,
}

export enum CompanyTierType {
    Primary,
    Secondary,
    Tertiary,
}

export enum UserType {
    Corporate,
    Individual,
}

export enum PaymentType {
    Others,
    CreditCard,
}

export enum SubscriptionFeeType {
    Other,
    TaxPodFee,
    AAESubscriptionFee,
    AskPodFee,
}

export enum AttachmentModule {
    Program = 1,
    ProgramChapter = 2,
    SpeakerImage = 3,
    SpeakerHeaderImage = 4,
    Article = 5,
    GuideAttachment = 6,
    BannerDesktopImage = 7,
    BannerTableImage = 8,
    BannerMobileImage = 9,
    UserProfileImage = 10,
    AAEAttachment = 11,
}

export enum ModuleType {
    Course = 1,
    Webinar = 2,
    TaxAMinute = 3,
    QuickGuide = 4,
    Article = 5,
    Announcement = 6,
    Others = 7,
    Aae = 8,
    Podcast = 10,
}

export enum Country {
    Malaysia = 0,
    Singapore = 1,
}
